import Splide from '@splidejs/splide';
import SplideCss from '@splidejs/splide/dist/css/splide-core.min.css';
import { Grid } from '@splidejs/splide-extension-grid';


document.addEventListener('DOMContentLoaded', function() {
  initSliders();
  initTabs();
  initFaqs();
  initListings();
  initHeaderSearch();
  initFacetWpFilters();
  initLightbox();

  var tab = document.getElementById('sowmedia-tabnavigatie');
  if ( tab == 'sowmedia-tabnavigatie') {
    var menuItem = jQuery('.wp-block-navigation__container  .current-menu-item');
    var menuContainer = jQuery('.wp-block-navigation__container');
    
    var scrollPosition = menuItem.offset().left + menuItem.outerWidth() / 2 - menuContainer.width() / 2 - 75;
    menuContainer.animate({ scrollLeft: scrollPosition }, 1000);
  }
});

document.addEventListener('facetwp-loaded', function() {

  setListingTitleAfterFiltering();

  if ( FWP.loaded ) {
    initSliders();
  }
  
});

function initSliders(){
  const sliderListings = document.querySelectorAll('.wp-block-sowmedia-listing.has-mobile-slider') || [];

  sliderListings.forEach(function(slider) {

    const arrows = slider.classList.contains('is-view-banner') ? true : false;
    const gap = slider.classList.contains('is-view-banner') ? '12px' : '32px';
    const padding = slider.classList.contains('is-view-banner') ? { left: 'var(--wp--preset--spacing--50)', right: '35%' } : { left: 'var(--wp--preset--spacing--50)', right: '25%' };
    const isGrid = slider.classList.contains('is-view-list') ? true : false;

    let args = {
      type: 'slide',
      pagination: false,
      gap: gap,
      arrows: arrows,
      perPage: 1,
      perMove: 1,
      mediaQuery: "min",
      padding: padding,
      arrowPath: 'M19.643 40 40 20 19.643 0l-5.555 5.47 10.855 10.664H0v7.731h24.944L14.088 34.53z',
      breakpoints: {
        1100: {
          destroy: true
        }
      }
    };

    if ( isGrid ) { 

      const columns = Number(slider.dataset.columns);
      const items = slider.querySelectorAll('.listing__post').length;
      const rows = Math.ceil(items / columns);

      args.grid = { 
        rows: rows, 
        columns: columns, 
        gap: {
          row: '12px',
          col: args.gap
        }
      };

    } 
    

    const splide = new Splide(slider, args);

    if ( isGrid) {

      splide.mount( { Grid } );

    } else {

      splide.mount();

    }
    
  });

  const sliderBlocks = document.querySelectorAll('.wp-block-sowmedia-slider') || [];

  sliderBlocks.forEach(function(slider) {

    const sliderType = slider.classList.contains('is-type-hero') ? 'hero' : 'screenshots';
    const hasProgress = slider.classList.contains('has-navigation-arrows-and-progress') && sliderType == 'hero' ? true : false;

    let splideOptions = {
      type: 'slide',
      pagination: false,
      perPage: 1,
      perMove: 1,
      arrowPath: 'M19.643 40 40 20 19.643 0l-5.555 5.47 10.855 10.664H0v7.731h24.944L14.088 34.53z'
    };

    if ( sliderType == 'hero' ) {

      splideOptions = {
        ...splideOptions,
        gap: '.5rem',
        padding: { left: 'var(--wp--preset--spacing--50)', right: '5%' },
        perPage: 1,
        breakpoints: {
          783: {
            gap: '5px',
          }
        }
      };

    } else if ( sliderType == 'screenshots' ) {

      splideOptions = {
        ...splideOptions,
        gap: '32px',
        perPage: 3,
        breakpoints: {
          783: {
            perPage: 1,
            padding: { left: 'var(--wp--preset--spacing--50)', right: '20%' },
            gap: '12px',
          }
        }
      };
    }

    const splide = new Splide(slider, splideOptions);

    if ( hasProgress ) {

      var bar = slider.querySelector('.wp-block-sowmedia-slider__progresss-bar');
    
      splide.on('mounted move', function () {
        var end  = splide.Components.Controller.getEnd() + 1;
        var rate = Math.min((splide.index + 1) / end, 1);
        bar.style.width = String(100 * rate) + '%';
      });

    }
    
    splide.mount();

  });

}

function initTabs() {

  document.querySelectorAll('.wp-block-sowmedia-tabs').forEach( ( el, i ) => {

    el.querySelectorAll('.wp-block-sowmedia-tab').forEach( ( tab, i ) => {
  
        const title = tab.getAttribute('data-title');
        const button = '<li><button aria-label="Ga naar tabblad '+title+'">'+title+'</button></li>';
  
        el.querySelector('.tabs__nav ul').insertAdjacentHTML('beforeend', button);
  
      });
  
    el.querySelectorAll('.tabs__nav button').forEach( ( button, i ) => {
  
        button.addEventListener('click', function(e) {
  
            e.preventDefault();
  
            el.querySelectorAll('.tabs__nav button').forEach( ( button, i ) => {
  
                button.classList.remove('active');
  
            });
  
            button.classList.add('active');
  
            el.querySelectorAll('.wp-block-sowmedia-tab').forEach( ( tab, i ) => {
  
                tab.classList.remove('active');
  
            });
  
            el.querySelectorAll('.wp-block-sowmedia-tab')[i].classList.add('active');
  
        });
  
    });
  
    el.querySelectorAll('.wp-block-sowmedia-tab')[0].classList.add('active');
    el.querySelectorAll('.tabs__nav button')[0].classList.add('active');
  
  });

}

function initFaqs() {
  
    document.querySelectorAll('.schema-faq-section').forEach( ( el, i ) => {
  
      el.querySelector('.schema-faq-question').onclick = function() {

        el.classList.toggle('schema-faq-section--open');
  
      };
  
    });
}

function initListings() {

  document.querySelectorAll('.wp-block-sowmedia-listing').forEach( ( listing, i ) => {

    const moreButton = listing.querySelector('.listing__more-button button');

    if ( moreButton ) {

      moreButton.onclick = function() {

        listing.querySelectorAll('.listing__post').forEach( ( post, i ) => {
  
          post.classList.remove('listing__post--hidden-mobile');
  
        });
  
        moreButton.style.display = 'none';
  
      };
      
    }

  });

}

function initHeaderSearch() {

  const searchTrigger = document.querySelector('#ast-mobile-header .pb-search-toggle');
  const search = document.querySelector('#ast-mobile-header .ast-header-search');
  const menuTrigger = document.querySelector('#ast-mobile-header .menu-toggle');

  searchTrigger.onclick = function() {

    // Open search
    search.classList.toggle('ast-header-search--open');

    // Close menu if open
    if ( menuTrigger.classList.contains('toggled') ) {
      menuTrigger.click();
    }
  }

  menuTrigger.onclick = function() {

    // Close search if menu opens
    if ( ! menuTrigger.classList.contains('toggled') ) {
      search.classList.remove('ast-header-search--open');
    }
    
  }

}

function initFacetWpFilters() {

  document.querySelectorAll('.wp-block-sowmedia-facetwp-filters').forEach( ( el, i ) => {

    el.querySelector('.wp-block-sowmedia-facetwp-filters__toggle').onclick = function() {

      el.classList.toggle('wp-block-sowmedia-facetwp-filters--open');

    };

  });

}

function initLightbox() {

  document.querySelectorAll('.wp-block-sowmedia-slider.is-type-screenshots').forEach( ( el, i ) => {

    el.querySelectorAll('img').forEach( ( img, i ) => {

      img.onclick = function() {

        const lightbox = basicLightbox.create(`
          <img src="${img.src}" style="max-width: 80vw; max-height: 80vh; display: block; margin: auto;">
          <div class="basicLightbox__close" onclick="basicLightbox.close();" role="button" aria-label="Sluit"></div>
        `, {
          onShow: function(instance) {
            instance.element().querySelector('.basicLightbox__close').onclick = function() {
              instance.close();
            }
          }
        });

        lightbox.show();

      };

    });

  });

}

function setListingTitleAfterFiltering() {

  // Loop through all listings that have a title
  document.querySelectorAll('.wp-block-sowmedia-listing[data-title-after-filtering]:has(.listing__title)').forEach( ( listing, i ) => {

    // Get current and new title
    let newTitle = listing.getAttribute('data-title-after-filtering');
    let title = listing.getAttribute('data-title');

    // Check if there are active facets
    let activeFacets = false;

    for (var facetName in FWP.facets) {
      if (FWP.facets[facetName].length > 0) {
          activeFacets = true;
          break;
      }
    }

    // Set new title if there is one and there are active facets
    listing.querySelector('.listing__title').innerHTML = ( newTitle && activeFacets ) ? newTitle : title;

  });

}